import { Box3, IPerspectiveCameraOptions, Vector3, ViewerApp } from "webgi";
import getAngleData from "./getAngleData";

export function getDistance(viewer: ViewerApp, camId: string): number {
  let meshBounds = new Box3().setFromObject(viewer.scene.modelRoot.children[0]);
  const size = meshBounds.getSize(new Vector3());
  // console.log("size", size);
  const maxSize = Math.max(size.x, size.y, size.z);
  // console.log("maxSize", maxSize);

  // Convert camera fov degrees to radians
  const cameraOptions =
    viewer.scene.activeCamera.getCameraOptions() as IPerspectiveCameraOptions;
  const fov = cameraOptions.fov;
  const { camOffset, minDistance } = getAngleData(camId);
  let padding = camOffset || 0;
  let w = maxSize + padding;
  let h = maxSize + padding;

  let fovX = fov * (viewer.canvas.width / viewer.canvas.height);
  let fovY = fov;

  let distanceX = w / 2 / Math.tan((Math.PI * fovX) / 360) + w / 2;
  let distanceY = h / 2 / Math.tan((Math.PI * fovY) / 360) + w / 2;

  let distance = Math.max(distanceX, distanceY, minDistance);
  return distance;
}
